import {
  Button,
  DialogContent,
  DialogContentText,
  List,
  ListItem,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Check, Delete, Edit } from "@material-ui/icons";
import { createReferralApplStatus, deleteReferralApplStatus, fetchReferralApplStatusForFlowApplicationStatus, updateReferralApplStatus } from "../../../../services/referralApplStatusService";
import { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";

import { Alert } from "@material-ui/lab";
import CustomAlert from "../../../components/CustomAlert";
import { Field } from "formik";
import { Autocomplete as FormikAutocomplete } from 'formik-material-ui-lab';
import { TextField as FormikTextField } from "formik-material-ui";
import { fetchReferralKinds } from "../../../../services/referralKindsService";
import useLocale from "../../../../hooks/useLocale";

const useStyles = makeStyles({
  itemRow: {
    maxWidth: 500,
    justifyContent: 'space-between',
    display: 'inline-flex',
    width: 'inherit',
    alignItems: 'center',
    backgroundColor: "gainsboro",
    borderRadius: 7,
    padding: 'inherit',
  },
  itemDetails: {
    display: 'inline-flex',
    flexDirection: 'column',
  },
  typography: {
    display: 'inline-flex',
  },
  typographyItemTitle: {
    fontWeight: 500,
    display: 'inline-flex',
    alignItems: 'center !important'
  },
  iconsStyles: {
    cursor: "pointer"
  },
  btn: {
    marginTop: 15,
  },
  typographyDiv: {
    height: 100,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
  },
  listTitle: {
    marginTop: 10,
  }
});

const Item = ({ item, handleItemRemove, handleItemEdit, t }) => {

  const [isEditing, setEditing] = useState(false);
  const [reportName, setReportName] = useState(item.report_name)
  const classes = useStyles();

  return <ListItem key={item.id}><div className={classes.itemRow}>

    <div className={classes.itemDetails}>
      <Typography className={classes.typographyItemTitle} >{t("Referral Kind")}{': '}</Typography>
      <Typography className={classes.typography}  >{item.dscr}</Typography>
    </div>
    <div className={classes.itemDetails}>
      {!isEditing ? <>
        <Typography className={classes.typographyItemTitle} >{t("Report Name")}{': '}</Typography>
        <Typography className={classes.typography} >
          {item.report_name.length > 15 ? item.report_name.substring(0, 15) + "..." : item.report_name}
        </Typography></> :
        <TextField
          defaultValue={reportName}
          required
          multiline
          rows={3}
          onChange={(e) => { setReportName(e.currentTarget.value); }}
          name="item_report_name"
          margin='normal'
          fullWidth
          label={t('Report Name')}
        />}
    </div>
    <div >
      {!isEditing ? <Edit className={classes.iconsStyles} htmlColor="#1E90FF" onClick={() => setEditing(true)} /> :
        <Check className={classes.iconsStyles} htmlColor="green" onClick={() => {
          setEditing(false);
          handleItemEdit(item, reportName)
        }} />}
      <Delete className={classes.iconsStyles} htmlColor="#B22222" onClick={() => handleItemRemove(item.id)} />
    </div>
  </div>
  </ListItem>
}

//Gets three arguments (@array,@fn to remove items,@fn to handle item edit) and uses custom Item Component inside
//returns a material - ui < List > component
const CustomList = ({ array, handleItemRemove, handleItemEdit }) => {
  const { t } = useLocale();
  const classes = useStyles();
  //item component


  return (<div>
    <Typography className={classes.listTitle} variant="h6">{t("Referral Kinds")}</Typography>
    {array?.length !== 0 ? <List>
      {array?.map((item) => {
        return (
          <Item key={item?.id} item={item} handleItemRemove={handleItemRemove} handleItemEdit={handleItemEdit} t={t} />
        )
      })}
    </List > : <div className={classes.typographyDiv}><Alert severity="info"><Typography color="textSecondary">{t("List is empty")}</Typography></Alert></div>
    }</div>)
}


const UpdateReferralKindToFlowForm = ({ setFieldValue, errors, touched, values, selectedItem }) => {
  const [error, setError] = useState("");
  const { t } = useLocale();
  const { data: refKinds } = useQuery('referralKinds', fetchReferralKinds);
  const [refKindsList, setRefKindsList] = useState([]);
  const [addToListError, setAddToListError] = useState("");
  const { data: referralApplStatus, refetch: refetchReferralApplStatusForFlowApplication } = useQuery(['referralApplStatusByFlowApplStatus', selectedItem?.id], () => fetchReferralApplStatusForFlowApplicationStatus(selectedItem?.id));
  const [addSuccess, setAddSuccess] = useState("");
  const [removeSuccess, setRemoveSuccess] = useState("");
  const [updateSuccess, setUpdateSuccess] = useState("");
  const classes = useStyles();

  const { mutate: addReferralKindToFlow } = useMutation(createReferralApplStatus, {
    onSuccess: (data, variables) => {
      setAddSuccess(t("Referral Kind added successfully to Flow Application Status"));
      setTimeout(() => setAddSuccess(''), 2000);
      refetchReferralApplStatusForFlowApplication(selectedItem?.id)
      let p = referralApplStatus?.map(ras => {
        return { id: ras.id, flow_appl_status_id: ras.flow_appl_status_id, referral_kind_id: ras.referral_kind_id, report_name: ras.report_name, dscr: ras.applKind }
      })
      setRefKindsList(p);
      setFieldValue('referral_kind', null);
      setFieldValue('report_name', '');
      setAddToListError("");
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  const { mutate: removeReferralKindToFlow } = useMutation(deleteReferralApplStatus, {
    onSuccess: (data) => {
      setRemoveSuccess(t("Referral Kind removed successfully from Flow Application Status"));
      setTimeout(() => setRemoveSuccess(''), 2000);
      refetchReferralApplStatusForFlowApplication(selectedItem?.id)
      let p = referralApplStatus?.map(ras => {
        return { id: ras.id, flow_appl_status_id: ras.flow_appl_status_id, referral_kind_id: ras.referral_kind_id, report_name: ras.report_name, dscr: ras.applKind }
      })
      setRefKindsList(p);
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  const { mutate: updateReferralKindToFlow } = useMutation(updateReferralApplStatus, {
    onSuccess: (data, variables) => {
      setUpdateSuccess(t("Referral Kind updated successfully"));
      setTimeout(() => setUpdateSuccess(''), 2000);
      refetchReferralApplStatusForFlowApplication(selectedItem?.id)
      let p = referralApplStatus?.map(ras => {
        return { id: ras.id, flow_appl_status_id: ras.flow_appl_status_id, referral_kind_id: ras.referral_kind_id, report_name: ras.report_name, dscr: ras.applKind }
      })
      setRefKindsList(p);
    },
    onError: (error) => {
      switch (error) {
        default: {
          setError(t("A network error occured. Please try again later"));
        }
      }
    },
  });

  //adds items to list
  const addToList = () => {
    if (!values.referral_kind || !values.report_name) {
      setAddToListError(t('Both fields required to add Referral Kind to Application Flow / Status'))
    } else {
      addReferralKindToFlowStatus(values.referral_kind, values.report_name)
    }
  }

  //removes item from the list
  const handleItemRemove = (id) => {
    removeReferralKindToFlowStatus(id);
  }

  //edits list item from the list
  const handleItemEdit = (item, reportName) => {
    updateReferralKindToFlowStatus(item, reportName)
  }

  //uses add mutation to add referral kind to flow appl status gets prfId and the new Array of prfs as params
  const addReferralKindToFlowStatus = (referral_kind, report_name) => {
    const valuesToSubmit = {
      flow_appl_status_id: selectedItem.id,
      referral_kind_id: referral_kind?.id,
      report_name: report_name
    }
    addReferralKindToFlow({ items: JSON.stringify([valuesToSubmit]) });
  }

  //uses remove mutation to remove referral Kind from flow appl status gets prfId and the new Array of prfs as params
  const removeReferralKindToFlowStatus = (id) => {
    const valuesToSubmit = {
      id: id
    }
    removeReferralKindToFlow({ items: JSON.stringify([valuesToSubmit]) });
  }

  //uses update mutation to remove referral Kind from flow appl status gets prfId and the new Array of prfs as params
  const updateReferralKindToFlowStatus = (item, report_name) => {
    const valuesToSubmit = {
      id: item.id,
      flow_appl_status_id: item.flow_appl_status_id,
      referral_kind_id: item.referral_kind_id,
      report_name: report_name
    }
    updateReferralKindToFlow({ ...valuesToSubmit });
  }

  useEffect(() => {
    let p = referralApplStatus?.map(ras => {
      return { id: ras?.id, flow_appl_status_id: ras?.flow_appl_status_id, referral_kind_id: ras?.referral_kind_id, report_name: ras?.report_name, dscr: ras?.applKind }
    })
    setRefKindsList(p);
  }, [referralApplStatus])

  return (
    <div style={{ maxHeight: 440 }}>
      <DialogContent>
        <DialogContentText>
          {t(
            "Fill in the form below and click on Add to add a Referral Kind to Application Flow / Status"
          )}
        </DialogContentText>
      </DialogContent>
      <CustomAlert
        open={!!error}
        close={() => {
          setError("");
        }}
        message={t("A network error occured, please try again later")}
      />
      <CustomAlert
        open={!!addSuccess}
        close={() => {
          setAddSuccess("");
        }}
        message={t("Referral Kind added successfully to Flow Application Status")}
        severity={"success"}
      />
      <CustomAlert
        open={!!removeSuccess}
        close={() => {
          setRemoveSuccess("");
        }}
        message={t("Referral Kind removed successfully from Flow Application Status")}
        severity={"success"}
      />
      <CustomAlert
        open={!!updateSuccess}
        close={() => {
          setUpdateSuccess("");
        }}
        message={t("Referral Kind updated successfully")}
        severity={"success"}
      />

      <DialogContent>
        <Field
          name="referral_kind"
          component={FormikAutocomplete}
          options={refKinds || []}
          getOptionLabel={(option) => option?.dscr || ""}
          getOptionSelected={(option, value) => option?.dscr === value?.dscr}
          renderInput={(params) => (
            <TextField
              {...params}
              error={touched['referral_kind'] && !!errors['referral_kind']}
              helperText={touched['referral_kind'] && errors['referral_kind']}
              label={t('Referral Kinds')}
              variant="outlined"
            />
          )}
        />

        <Field
          variant="outlined"
          margin="normal"
          multiline
          rows={3}
          name='report_name'
          component={FormikTextField}
          fullWidth
          label={t('Report Name')}
        />

        <Button className={classes.btn} variant="contained" color='primary' onClick={() => { addToList(); }}>
          {t('Add to list')}
        </Button>

        <Typography color="error">
          {addToListError}
        </Typography>

        {refKindsList ?
          <CustomList
            array={refKindsList}
            handleItemRemove={handleItemRemove}
            handleItemEdit={handleItemEdit} /> :
          null}

      </DialogContent>

    </div>
  );
};

export default UpdateReferralKindToFlowForm;